export default __webpack_public_path__ + "static/media/vf-associate-as-parent.b5320d42.svg";